import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { XCircle } from "lucide-react";
import usePageSeo from "@/hooks/usePageSeo";

export default function PaymentCancel() {
  const nav = useNavigate();
  usePageSeo({
    title: "Payment canceled — Dividend Portfolio Planner",
    description: "Your DPP Pro checkout was canceled. No charge was made — pick up where you left off any time from the pricing page.",
    path: "/payment/cancel",
    noindex: true,
  });
  return (
    <div className="max-w-2xl mx-auto px-6 py-20">
      <Card>
        <CardContent className="p-10 text-center">
          <div className="w-14 h-14 rounded-full bg-muted grid place-items-center mx-auto">
            <XCircle className="w-8 h-8 text-muted-foreground" />
          </div>
          <h1 className="serif text-3xl mt-4">Payment canceled</h1>
          <p className="text-muted-foreground mt-2 text-sm">No charge was made. You can pick up where you left off any time.</p>
          <div className="mt-8 flex gap-2 justify-center">
            <Button className="rounded-full" onClick={() => nav("/pricing")}>Back to pricing</Button>
            <Button variant="outline" className="rounded-full" onClick={() => nav("/dashboard")}>Open dashboard</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
